import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectAppNumber } from "../feature/app.Slice";
import Logout from "../components/LogOut";

/**
 * Header est un composant qui affiche le logo et la barre de navigation en haut de l'application.
 * Il contient des liens de navigation vers différentes pages de l'application.
 * Il utilise le composant NavLink de 'react-router-dom' pour créer ces liens.
 * Il utilise le hook useSelector de 'react-redux' pour accéder à l'état de l'utilisateur dans le store Redux.
 */

export const resolveHeaderAppNumber = (currentAppNumber, storedApp, search) => {
  let resolved = currentAppNumber;
  if (resolved === null || resolved === undefined) {
    if (storedApp) {
      resolved = parseInt(storedApp, 10);
    } else {
      const urlParams = new URLSearchParams(search);
      const appParam = urlParams.get("app");
      /* istanbul ignore next */
      if (appParam) {
        resolved = parseInt(appParam, 10);
      }
    }
  }
  return resolved;
};

const Header = () => {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const appNumber = useSelector(selectAppNumber);

  // États pour le logo et le texte dynamiques
  const [logo, setLogo] = useState("");

  const [isApp4, setIsApp4] = useState(false);
  const [isApp6, setIsApp6] = useState(false);

  useEffect(() => {
    // Debug : afficher appNumber pour vérifier
    console.log("Header - appNumber depuis Redux:", appNumber);

    // Déterminer quel appNumber utiliser (Redux ou fallback localStorage)
    let currentAppNumber = appNumber;
    const storedApp = localStorage.getItem("devAppNumber");
    currentAppNumber = resolveHeaderAppNumber(
      currentAppNumber,
      storedApp,
      window.location.search
    );

    // Déterminer si on est sur App4
    setIsApp4(currentAppNumber === 4);
    setIsApp6(currentAppNumber === 6);

    // Utiliser appNumber pour déterminer le logo
    if (currentAppNumber === 2) {
      console.log("Header - Logo App2 chargé");
      setLogo(require("../asset/logoKlesiaMut.webp"));
    } else if (currentAppNumber === 3) {
      console.log("Header - Logo App3 chargé");
      setLogo(require("../asset/KLESIACarceptLogo.webp"));
    } else if (currentAppNumber === 4) {
      console.log("Header - Logo App4 (GHR) chargé");
      setLogo(require("../asset/GHR_logo.png"));
    } else if (currentAppNumber === 5) {
      console.log("Header - Logo App5 (AGPM) chargé");
      setLogo(require("../asset/logo_agpm.webp"));
    } else if (currentAppNumber === 6) {
      console.log("Header - Logo App6 (MEDEF) chargé");
      setLogo(require("../asset/logo_medef.webp"));
    } else {
      // App 1 ou par défaut (si appNumber est null/undefined, afficher App1)
      console.log(
        "Header - Logo App1 chargé (par défaut, appNumber:",
        currentAppNumber
      );
      setLogo(require("../asset/logoKlesia.webp"));
    }
  }, [appNumber]);
  const headerClass = isApp4
    ? "bg-gradient-to-r from-theme-primary to-theme-primary-active text-white shadow-xl rounded-theme p-3 md:p-4 flex flex-col lg:flex-row justify-between items-center gap-3 md:gap-4"
    : `bg-white shadow-theme rounded-theme px-3 md:px-4 ${
        isApp6 ? "py-6 md:py-10" : "py-3 md:py-4"
      } flex flex-col lg:flex-row justify-between items-center gap-3 md:gap-4`;

  return (
    <header className={headerClass}>
      <NavLink to="/" className="flex items-center">
        <img
          src={logo}
          className={`h-auto ${
            isApp4
              ? "max-w-[180px] md:max-w-[220px] lg:max-w-[250px]"
              : "max-w-[120px] md:max-w-[150px]"
          }`}
          alt="App Logo"
        />
      </NavLink>
      <nav className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-6 md:sm:space-x-8">
        {isLoggedIn ? (
          <>
            <NavLink
              to="/"
              className={(nav) =>
                nav.isActive ? "nav-link-active-theme" : "nav-link-theme"
              }
            >
              Accueil
            </NavLink>
            <NavLink
              to="/Profil"
              className={(nav) =>
                nav.isActive ? "nav-link-active-theme" : "nav-link-theme"
              }
            >
              Mon profil
            </NavLink>
            <Logout />
          </>
        ) : (
          <NavLink
            to="/Signin"
            className={(nav) =>
              nav.isActive ? "nav-link-active-theme" : "nav-link-theme"
            }
          >
            Se connecter
          </NavLink>
        )}
      </nav>
    </header>
  );
};

export default Header;
